export const blockIconsCommonactionsUploadFileNew = (
	<span className='material-symbols-outlined'>upload_file</span>
);
